import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=eddfa65e&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=eddfa65e&scoped=true&lang=css&"
import style1 from "@/assets/css/content.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/font.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddfa65e",
  null
  
)

export default component.exports